import { NetSuiteGetClassesResponseSchema, type NetSuiteGetClassesResponse } from '@vy/api-definition';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { withDefault } from '@vy/utils';
import { QueryClient, useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';
import { useActivatedIntegration } from '../../../use-activated-integration';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';

export function useNetSuiteClasses(
  subsidiaryId?: string,
  options?: CustomUseQueryOptions<NetSuiteGetClassesResponse>,
) {
  const isNetSuiteEnabled = useActivatedIntegration(INTEGRATION_PROVIDERS.netSuite, { suspense: true });

  const isEnabledInOptions = withDefault(options?.enabled, true);
  const enabled = isEnabledInOptions && isNetSuiteEnabled;

  const queryKey = queryKeys.netSuiteClasses();

  const { data } = useQuery(
    queryKey,
    () => getNetSuiteClassesQueryFunction(subsidiaryId),
    {
      suspense: true,
      ...options,
      enabled,
    },
  );

  return data?.classes ?? [];
}

async function getNetSuiteClassesQueryFunction(subsidiaryId?: string) {
  const api = getPrivateApi();
  const netSuiteGetClassesResponse = await api.netSuiteGetClasses({ subsidiaryId });

  return NetSuiteGetClassesResponseSchema.parse(netSuiteGetClassesResponse);
}

export async function prefetchNetSuiteClasses(queryClient: QueryClient) {
  return queryClient.prefetchQuery(queryKeys.netSuiteClasses(), () =>
    getNetSuiteClassesQueryFunction(undefined),
  );
}
